module.exports = __webpack_public_path__ + "img/fb.f715d2e2.svg";